import { defineComponent, reactive, ref, computed, toRef, watch, resolveComponent, openBlock, createBlock, mergeProps } from 'vue';
import { watchDebounced } from '@vueuse/core';
import { K, _, c as ie, r as re } from '../OrAutocompleteV3-8c6de221.js';
import { OrInputV3 as script$1 } from '../or-input-v3/index.js';
import { InputBoxVariant } from '../or-input-box-v3/index.js';
import '@onereach/styles/screens.json';
import '@onereach/styles/tailwind.config.json';
import 'lodash/get';
import 'lodash/isElement';
import '../or-error-v3/index.js';
import '../or-hint-v3/index.js';
import '../or-icon-button-v3/index.js';
import '../or-icon-v3/index.js';
import '../or-tooltip-v3/index.js';
import '../or-popover-v3/index.js';
import '@floating-ui/dom';
import '../or-bottom-sheet-v3/index.js';
import '../or-overlay-v3/index.js';
import '../or-teleport-v3/index.js';
import '../OrInlineInputV3-061441a3.js';
import '../or-inline-input-box-v3/index.js';
import '../or-text-v3/index.js';
import '../or-label-v3/index.js';
import '../or-loader-v3/index.js';
import '../or-menu-item-v3/index.js';
import '../or-tag-input-v3/index.js';
import '../or-tags-v3/index.js';
import '../or-button-v3/index.js';
import '../or-tag-v3/index.js';

var script = defineComponent({
  name: 'OrSearch',
  components: {
    OrInput: script$1
  },
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  props: {
    modelValue: {
      type: undefined,
      default: undefined
    },
    variant: {
      type: String,
      default: undefined
    },
    size: {
      type: String,
      default: undefined
    },
    placeholder: {
      type: String,
      default: 'Search'
    },
    debounce: {
      type: Number,
      default: 500
    }
  },
  emits: ['update:modelValue', 'input', 'keydown', 'keyup', 'focus', 'blur', 'search', 'clear'],
  expose: ['root', 'clear', 'focus', 'blur'],
  setup(props, context) {
    const controlAttributes = reactive({
      id: K(),
      ..._(),
      ...ie()
    });
    // Refs & Styles
    const root = ref();
    const rootStyles = computed(() => ['or-search-v3', ...(props.variant === InputBoxVariant.Embedded ? ['grow'] : [])]);
    // State
    const model = re(toRef(props, 'modelValue'), context.emit);
    const draft = ref(props.modelValue);
    watch(model, value => {
      draft.value = value;
    });
    watchDebounced(draft, value => {
      if (value) {
        context.emit('search', model.value = value);
      }
    }, {
      debounce: toRef(props, 'debounce')
    });
    watch(draft, (nextValue, prevValue) => {
      if (!nextValue && prevValue) {
        context.emit('search', model.value = nextValue);
        context.emit('clear');
      }
    });
    // Methods
    function clear() {
      var _a;
      (_a = root.value) === null || _a === void 0 ? void 0 : _a.clear(); // fixes error TS2349
    }
    function focus() {
      var _a;
      (_a = root.value) === null || _a === void 0 ? void 0 : _a.focus(); // fixes error TS2349
    }
    function blur() {
      var _a;
      (_a = root.value) === null || _a === void 0 ? void 0 : _a.blur(); // fixes error TS2349
    }
    return {
      controlAttributes,
      root,
      rootStyles,
      model,
      draft,
      clear,
      focus,
      blur
    };
  }
});

function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrInput = resolveComponent("OrInput");
  return openBlock(), createBlock(_component_OrInput, mergeProps({
    ref: 'root'
  }, _ctx.controlAttributes, {
    modelValue: _ctx.draft,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.draft = $event),
    class: _ctx.rootStyles,
    type: 'search',
    variant: _ctx.variant,
    size: _ctx.size,
    placeholder: _ctx.placeholder,
    onInput: _cache[1] || (_cache[1] = $event => _ctx.$emit('input', $event)),
    onKeydown: _cache[2] || (_cache[2] = $event => _ctx.$emit('keydown', $event)),
    onKeyup: _cache[3] || (_cache[3] = $event => _ctx.$emit('keyup', $event)),
    onFocus: _cache[4] || (_cache[4] = $event => _ctx.$emit('focus', $event)),
    onBlur: _cache[5] || (_cache[5] = $event => _ctx.$emit('blur', $event))
  }), null, 16 /* FULL_PROPS */, ["modelValue", "class", "variant", "size", "placeholder"]);
}

script.render = render;
script.__file = "src/components/or-search-v3/OrSearch.vue";

export { script as OrSearchV3 };
